import { FC, FormEvent, useState } from "react"
import { Search } from "lucide-react"

interface Props {
  initialValue?: string
  isLoading: boolean
  onSubmit: (params: { key?: string; id?: number }) => void
}

const LookupForm: FC<Props> = ({ initialValue = "", isLoading, onSubmit }) => {
  const [input, setInput] = useState(initialValue)

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault()
    const trimmed = input.trim()
    if (!trimmed) return

    // If the input is a pure integer, treat as enrollment ID
    if (/^\d+$/.test(trimmed)) {
      onSubmit({ id: parseInt(trimmed, 10) })
    } else {
      onSubmit({ key: trimmed })
    }
  }

  const isValid = input.trim().length > 0 && input.trim().length <= 128

  return (
    <form onSubmit={handleSubmit} className="flex gap-3 items-end">
      <div className="flex-1">
        <label className="block text-sm font-medium text-neutral-700 mb-1">
          Idempotency key or enrollment ID
        </label>
        <div className="relative">
          <Search
            size={16}
            className="absolute left-3 top-1/2 -translate-y-1/2 text-neutral-400"
          />
          <input
            type="text"
            value={input}
            onChange={e => setInput(e.target.value)}
            placeholder="e.g. enroll-ff8d4a5e-63bc-42e8-bfad-26c823c8444a or 42"
            className="w-full rounded-md border border-neutral-300 pl-10 pr-3 py-2 text-sm focus:border-primary-500 focus:ring-1 focus:ring-primary-500"
          />
        </div>
        {input.trim().length > 128 && (
          <p className="text-red-500 text-xs mt-1">
            Must be 128 characters or fewer
          </p>
        )}
      </div>
      <button
        type="submit"
        disabled={!isValid || isLoading}
        className="rounded-md bg-primary-600 px-5 py-2 text-sm font-medium text-white hover:bg-primary-700 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
      >
        {isLoading ? "Loading..." : "Look up"}
      </button>
    </form>
  )
}

export default LookupForm
